import { render } from "./FooterCom.vue?vue&type=template&id=bdc572b8&scoped=true"
const script = {}

import "./FooterCom.vue?vue&type=style&index=0&id=bdc572b8&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bdc572b8"]])

export default __exports__